'use client'

import { useSearchStore } from '@stores/search.store'

import { useEffect, useRef, type JSX } from 'react'

import type { JobPageItem, JobSearch } from '@types'

import PageViewEvent from 'src/app/page-view-event'

import { emailDailyRecommendationsRedirectEvent, jobPageViewEvent } from '@lib/analytics-events'
import { sendGTMEvent } from '@lib/helpers/client'

type PageEventProps = {
  job: JobPageItem
  search: JobSearch
}

export default function PageEvent({ job, search }: PageEventProps): JSX.Element {
  const serpPositionClicked = useSearchStore((state) => state.serpPositionClicked)
  // `eventSent` is never read for rendering, only used to stop a second fire if `serpPositionClicked`
  // (resolved asynchronously from the store) settles just after mount — a ref guard says the same
  // thing without a state update. [S20-865]
  const eventSentRef = useRef(false)

  useEffect(() => {
    if (eventSentRef.current) return
    if (search.dailyApply) {
      emailDailyRecommendationsRedirectEvent(search, parseInt(search.dailyApply, 10) + 1, job)
    }
    window?.dataLayer?.push?.({ 'Job ID': job.id })
    sendGTMEvent('jobPageOpened')
    jobPageViewEvent(job, search, String(serpPositionClicked))
    eventSentRef.current = true
  }, [job, search, serpPositionClicked])
  return <PageViewEvent location="job" />
}
